import { render, staticRenderFns } from "./event-stage-header.vue?vue&type=template&id=5ba12aa3&scoped=true"
import script from "./event-stage-header.vue?vue&type=script&lang=js"
export * from "./event-stage-header.vue?vue&type=script&lang=js"
import style0 from "./event-stage-header.vue?vue&type=style&index=0&id=5ba12aa3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba12aa3",
  null
  
)

export default component.exports